import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Drama, Settings, ShoppingCart } from "lucide-react";
import { IMAGES } from "../mock";
import { FeaturesBar } from "../components/Footer";
import PaintEdges from "../components/PaintEdges";

const categories = [
  {
    icon: Drama,
    iconBg: "bg-gradient-to-br from-[#1b9ad6] to-[#1273a8]",
    title: "COSPLAY",
    text: "3D-gedruckte Rüstungen, Requisiten, Accessoires und weitere Cosplay-Projekte. Für alle, die ihre Charaktere zum Leben erwecken möchten.",
    btn: "Zur Kategorie",
    to: "/cosplay",
    image: IMAGES.cosplayArmor,
  },
  {
    icon: Settings,
    iconBg: "bg-gradient-to-br from-[#63b93c] to-[#3f8f2a]",
    title: "3D-DRUCK AUF ANFRAGE",
    text: "Du hast eine Idee oder brauchst etwas Bestimmtes? Ich fertige individuelle 3D-Drucke nach deinen Vorstellungen an.",
    btn: "Jetzt anfragen",
    to: "/3d-druck",
    image: IMAGES.printerClose,
  },
  {
    icon: ShoppingCart,
    iconBg: "bg-gradient-to-br from-[#1b9ad6] to-[#1273a8]",
    title: "FERTIGE 3D-PRODUKTE",
    text: "Hier findest du bereits fertig gedruckte Produkte, die direkt gekauft werden können. Schnell, einfach und zuverlässig.",
    btn: "Produkte ansehen",
    to: "/produkte",
    image: IMAGES.animeFigures,
  },
];

const Home = () => {
  return (
    <main>
      {/* Hero */}
      <section className="relative overflow-hidden bg-gradient-to-b from-[#dff2fc] via-[#ecf9ee] to-[#fff6ea]">
        <PaintEdges from="#1b9ad6" via="#7cc24a" to="#f7941e" />
        <div className="relative mx-auto max-w-[1440px] px-4 sm:px-8 py-14 lg:py-20 grid lg:grid-cols-2 gap-12 items-center">
          <div>
            <p className="fade-up font-script text-2xl sm:text-3xl text-slate-700">
              Deine Idee. <span className="text-[#1b9ad6]">Unser 3D-Druck.</span>
            </p>
            <h1 className="fade-up-1 mt-3 font-display font-extrabold leading-[1.02] text-[clamp(2.6rem,6vw,4.6rem)] tracking-tight">
              <span className="text-[#1b7fc1]">INDIVIDUELL.</span>{" "}
              <span className="text-[#6fbf3f]">KREATIV.</span>
              <br />
              <span className="bg-gradient-to-r from-[#1b7fc1] via-[#6fbf3f] to-[#f7941e] bg-clip-text text-transparent">
                EINZIGARTIG.
              </span>
            </h1>
            <p className="fade-up-2 mt-6 max-w-xl text-lg text-slate-600 leading-relaxed">
              Ob Cosplay, individuelle 3D-Drucke oder fertige Produkte – bei TimerStore
              bekommst du hochwertige 3D-Drucke mit Liebe zum Detail.
            </p>
            <div className="fade-up-3 mt-8">
              <Link to="/produkte" className="btn-gradient">
                Produkte entdecken <ArrowRight className="h-5 w-5" />
              </Link>
            </div>
          </div>

          <div className="relative fade-up-2">
            <div className="absolute -inset-4 rounded-[2.5rem] bg-gradient-to-tr from-sky-200/60 via-lime-200/50 to-amber-200/60 blur-xl" />
            <img
              src={IMAGES.printerColor}
              alt="3D-Drucker mit Figur"
              className="relative rounded-[2rem] shadow-2xl shadow-sky-200/60 w-full h-[340px] sm:h-[440px] object-cover"
            />
            <img
              src={IMAGES.animeFigures}
              alt="3D-gedruckte Figuren"
              className="absolute -bottom-8 -left-6 sm:-left-10 w-36 sm:w-48 h-28 sm:h-36 object-cover rounded-2xl border-4 border-white shadow-xl rotate-[-4deg]"
            />
            <img
              src={IMAGES.dragon}
              alt="Drachenfigur"
              className="absolute -top-6 -right-4 sm:-right-8 w-28 sm:w-40 h-28 sm:h-40 object-cover rounded-2xl border-4 border-white shadow-xl rotate-[5deg]"
            />
          </div>
        </div>
      </section>

      {/* Kategorie-Karten */}
      <section className="relative overflow-hidden bg-gradient-to-b from-white via-[#f4fbfd] to-white">
        <PaintEdges from="#f7941e" via="#7cc24a" to="#1b9ad6" opacity={0.3} />
        <div className="relative mx-auto max-w-[1440px] px-4 sm:px-8 py-16">
        <div className="grid md:grid-cols-3 gap-8">
          {categories.map((c, i) => (
            <article key={c.title} className={`card-soft fade-up-${i + 1}`}>
              <div className="relative">
                <img src={c.image} alt={c.title} className="h-56 w-full object-cover" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/25 to-transparent" />
                <div
                  className={`absolute -bottom-8 left-6 h-16 w-16 rounded-full ${c.iconBg} border-4 border-white shadow-lg flex items-center justify-center`}
                >
                  <c.icon className="h-8 w-8 text-white" strokeWidth={2} />
                </div>
              </div>
              <div className="pt-12 px-6 pb-7">
                <h3 className="font-display text-2xl font-extrabold text-slate-800">{c.title}</h3>
                <p className="mt-3 text-slate-600 leading-relaxed min-h-[96px]">{c.text}</p>
                <Link to={c.to} className="btn-gradient w-full mt-4">
                  {c.btn} <ArrowRight className="h-5 w-5" />
                </Link>
              </div>
            </article>
          ))}
        </div>
        </div>
      </section>

      <FeaturesBar />
    </main>
  );
};

export default Home;
